import { render, staticRenderFns } from "./ProfilePerformanceStatItem.vue?vue&type=template&id=5e7908ef&lang=pug&"
import script from "./ProfilePerformanceStatItem.vue?vue&type=script&lang=js&"
export * from "./ProfilePerformanceStatItem.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePerformanceStatItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports